import PropTypes from 'prop-types';
import { Component } from 'react';
import classnames from 'classnames';
import theme from './CellCheckbox.module.scss';

import { SELECTION_MODE } from '../utils/constants';

/**
 * Cell renderer that displays a checkbox
 */
class CellCheckbox extends Component {
	shouldComponentUpdate(nextProps) {
		return (
			this.props.cellData !== nextProps.cellData ||
			this.props.columnData !== nextProps.columnData ||
			this.props.rowData !== nextProps.rowData ||
			this.props.rowIndex !== nextProps.rowIndex
		);
	}

	render() {
		const { cellData, columnData, rowData, rowIndex } = this.props;
		const { id, label, selectionMode, onChange, getRowState } = columnData;
		const { disabled = false } = (getRowState && getRowState(rowData)) || {};
		const type = selectionMode === SELECTION_MODE.SINGLE ? 'radio' : 'checkbox';

		return (
			<div className={classnames('tc-list-checkbox', theme['tc-list-checkbox'])}>
				<div className={classnames('checkbox', { disabled })}>
					<label htmlFor={id && `${id}-${rowIndex}-check`}>
						<input
							id={id && `${id}-${rowIndex}-check`}
							type={type}
							onChange={e => {
								onChange(e, rowData);
							}}
							checked={cellData}
							disabled={disabled}
						/>
						<span className="tc-cell-checkbox">
							<span className="sr-only">{label}</span>
						</span>
					</label>
				</div>
			</div>
		);
	}
}

CellCheckbox.displayName = 'VirtualizedList(CellCheckbox)';
CellCheckbox.propTypes = {
	// The cell value : props.rowData[props.dataKey]
	cellData: PropTypes.bool,
	// The custom props passed to <VirtualizedList.Content columnData={}>.
	columnData: PropTypes.shape({
		selectionMode: PropTypes.string,
		getRowState: PropTypes.func,
		// The List id. This is used as the checkbox id prefix.
		id: PropTypes.string,
		// The checkbox label.
		label: PropTypes.string,
		// The onChange callback triggered on checkbox toggle.
		onChange: PropTypes.func.isRequired,
	}),
	// The collection item.
	rowData: PropTypes.object, // eslint-disable-line
	// The collection item index.
	rowIndex: PropTypes.number,
};

export default CellCheckbox;
